<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="vol-1-dedication">
<div class="text" id="vol-1-dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For Karen, who gave me the courage to write this book when the demons in my head told me to play it safe.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001dedication.vue?7f74bca9